import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=2d64a614"
import script from "./addDialog.vue?vue&type=script&lang=js"
export * from "./addDialog.vue?vue&type=script&lang=js"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=2d64a614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports